import type {RouteParams} from 'types/routes'
import {MYPAGE_PATHS} from 'consts/paths'
import {ExtendChildcareFlow} from 'pages/withAuth/mypage/procedures/extendChildcare/flow'

export const ExtendChildcareRoutes: RouteParams[] = [
  {
    key: '/mypage/extend_childcare/flow/:id',
    path: MYPAGE_PATHS.PROCEDURES.EXTEND_CHILDCARE.FLOW,
    component: ExtendChildcareFlow,
    exact: true,
  },
]
